import { Input, Select } from "@legal-500/legal500-design-system";
import { useFieldArray, useFormContext } from "react-hook-form";
import {
  SUBTYPES,
  SUBTYPE_LABELS,
  SUBMISSION_TYPES,
  REFEREE_TYPES,
  defaultSubmissionType,
} from "./rankingTableConstants";
import styles from "./NewRankingTablesFields.module.css";

export type NewRankingTableValues = {
  name: string;
  subtype: string;
  submissionType: string;
  refereeType: string;
};

type NewRankingTablesFormValues = { rankingTables: NewRankingTableValues[] };

const SUBTYPE_OPTIONS = [
  { value: "", label: "Select..." },
  ...SUBTYPES.map(subtype => ({ value: subtype, label: SUBTYPE_LABELS[subtype] })),
];

export function NewRankingTablesFields() {
  const { register, control, setValue, formState } = useFormContext<NewRankingTablesFormValues>();
  const { fields, append, remove } = useFieldArray({ control, name: "rankingTables" });
  const tableErrors = formState.errors.rankingTables;

  return (
    <>
      {fields.map((field, index) => {
        const number = index + 1;
        return (
          <div key={field.id} className={styles.tableCard}>
            <div className={styles.tableCardHeader}>
              <span className={styles.tableCardTitle}>Table {number}</span>
              <button
                type="button"
                className={styles.removeButton}
                onClick={() => remove(index)}
                aria-label={`Remove table ${number}`}
              >
                ×
              </button>
            </div>
            <div className={styles.tableFields}>
              <Input
                id={`rt-name-${index}`}
                className={styles.required}
                label={`Table ${number} name`}
                fullWidth
                aria-required="true"
                placeholder="e.g. Leading Individuals"
                error={tableErrors?.[index]?.name?.message}
                {...register(`rankingTables.${index}.name`)}
              />
              <Select
                id={`rt-subtype-${index}`}
                className={styles.required}
                label={`Table ${number} subtype`}
                fullWidth
                aria-required="true"
                options={SUBTYPE_OPTIONS}
                error={tableErrors?.[index]?.subtype?.message}
                {...register(`rankingTables.${index}.subtype`, {
                  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => {
                    setValue(
                      `rankingTables.${index}.submissionType`,
                      defaultSubmissionType(event.target.value),
                    );
                  },
                })}
              />
              <Select
                id={`rt-submission-${index}`}
                label={`Table ${number} submission type`}
                fullWidth
                options={SUBMISSION_TYPES}
                {...register(`rankingTables.${index}.submissionType`)}
              />
              <Select
                id={`rt-referee-${index}`}
                label={`Table ${number} referee type`}
                fullWidth
                options={REFEREE_TYPES}
                {...register(`rankingTables.${index}.refereeType`)}
              />
            </div>
          </div>
        );
      })}
      <button
        type="button"
        className={styles.addTableButton}
        onClick={() => append({ name: "", subtype: "", submissionType: "", refereeType: "" })}
      >
        + Add ranking table
      </button>
    </>
  );
}
